import { useEffect } from "react";

declare global {
  interface Window {
    __hhWidgetScriptLoaded?: boolean;
  }
}

const WIDGET_SRC =
  "https://rpojgouloqkzbgaxfxyr.supabase.co/functions/v1/get-widget?token=7961a554-b46f-43d6-a083-7da43b668a54&v=1.6";

const scheduleIdleTask = (callback: () => void) => {
  if (typeof window === "undefined") return () => undefined;

  if ("requestIdleCallback" in window) {
    const id = window.requestIdleCallback(callback, { timeout: 2500 });
    return () => window.cancelIdleCallback(id);
  }

  const timeout = setTimeout(callback, 1800);
  return () => clearTimeout(timeout);
};

const DeferredThirdPartyScripts = () => {
  useEffect(() => {
    if (typeof document === "undefined" || window.__hhWidgetScriptLoaded) return;

    const injectWidget = () => {
      if (window.__hhWidgetScriptLoaded) return;
      const existing = document.querySelector<HTMLScriptElement>(`script[src="${WIDGET_SRC}"]`);
      if (existing) {
        window.__hhWidgetScriptLoaded = true;
        return;
      }

      const script = document.createElement("script");
      script.src = WIDGET_SRC;
      script.async = true;
      script.defer = true;
      script.crossOrigin = "anonymous";
      script.onload = () => {
        window.__hhWidgetScriptLoaded = true;
      };
      document.body.appendChild(script);
    };

    const cleanup = scheduleIdleTask(injectWidget);
    return cleanup;
  }, []);

  return null;
};

export default DeferredThirdPartyScripts;
